require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-raincity-bike-crew.json") })
        }
      }, "path---projects-raincity-bike-crew");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projects-raincity-bike-crew!./.cache/json/projects-raincity-bike-crew.json
// module id = 531
// module chunks = 231608221292675